import { SubtractIcon } from "@phosphor-icons/react";

import type { CarouselSlide } from "@alpacahq/ui/old";

export interface FpslSlideProps {
  onEnroll: () => void;
}

export const fpslSlide = ({ onEnroll }: FpslSlideProps): CarouselSlide => ({
  id: "fpsl",
  title: <h2 className="m-0 font-semibold text-gray-800">Stock Lending</h2>,
  description: (
    <span className="text-gray-700 text-sm">
      Earn extra income by lending shares — automated, cash-backed, and fully
      under your control. Trade, sell, or opt out anytime.
    </span>
  ),
  icon: <SubtractIcon size={24} />,
  learnMoreLink: "https://alpaca.markets/support/tag/stock-lending",
  button: {
    label: "Enroll Now",
    onClick: onEnroll,
  },
});
